// Model Link Validation -強FORCE BLOCK
  (function() {
    'use strict';

    let attemptedSubmit = false;
    let modelLinkInput = null;
    let linkError = null;
    let linkCount = null;
    let container = null;

    function init() {
      modelLinkInput = document.querySelector('[data-model-link-input]');
      linkError = document.getElementById('link-error');
      linkCount = document.querySelector('.model-link-count');
      container = document.querySelector('.product-model-link-container');

      if (!modelLinkInput) {
        console.log('Model link input not found');
        return;
      }

      console.log('Model link validation initialized');

      // Update character count
      modelLinkInput.addEventListener('input', function() {
        const value = this.value.trim();
        linkCount.textContent = value.length;

        if (attemptedSubmit) {
          validateAndShowFeedback();
        }
      });

      // Block ALL form submissions
      blockFormSubmissions();

      // Block Add to Cart buttons
      blockAddToCartButtons();

      // Block Buy Now button
      blockBuyNowButton();
    }

    function blockFormSubmissions() {
      // Find all product forms
      const forms = document.querySelectorAll('form[action*="/cart/add"], product-form form');

      forms.forEach(form => {
        form.addEventListener('submit', function(e) {
          attemptedSubmit = true;

          if (!validateAndShowFeedback()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showError();
            return false;
          }
        }, true);
      });
    }

    function blockAddToCartButtons() {
      // Find all Add to Cart buttons
      const buttons = document.querySelectorAll(
        'button[name="add"], ' +
        'button[type="submit"][form*="product"], ' +
        '[data-testid="ProductSubmitButton-productSubmitButton"], ' +
        '.product-form__submit'
      );

      buttons.forEach(button => {
        // Remove all existing click handlers
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        // Add our validation handler
        newButton.addEventListener('click', function(e) {
          attemptedSubmit = true;

          if (!validateAndShowFeedback()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showError();
            return false;
          }
        }, true);
      });
    }

    function blockBuyNowButton() {
      // Find Buy Now button
      const buyButtons = document.querySelectorAll(
        '[data-testid="Checkout-button"], ' +
        'button[name="checkout"], ' +
        '.shopify-payment-button__button'
      );

      buyButtons.forEach(button => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener('click', function(e) {
          attemptedSubmit = true;

          if (!validateAndShowFeedback()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showError('⚠️ Please enter a valid model link before checkout!');
            return false;
          }
        }, true);
      });
    }

    function validateAndShowFeedback() {
      if (!modelLinkInput) return false;

      const value = modelLinkInput.value.trim();
      const isValidUrl = value.length > 10 && (value.startsWith('http://') || value.startsWith('https://'));

      if (!isValidUrl) {
        linkError.style.display = 'block';
        modelLinkInput.classList.add('error-state');
        modelLinkInput.style.borderColor = '#ff0000';
        modelLinkInput.setAttribute('placeholder', 'REQUIRED: Enter model link!');
        return false;
      } else {
        linkError.style.display = 'none';
        modelLinkInput.classList.remove('error-state');
        modelLinkInput.style.borderColor = '#00ffff';
        modelLinkInput.setAttribute('placeholder', 'https://qe.threedium.io/...');
        return true;
      }
    }

    function showError(message) {
      message = message || '⚠️ Please enter a valid model link before adding to cart!';

      // Scroll to field
      if (modelLinkInput) {
        modelLinkInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        modelLinkInput.focus();
      }

      // Shake animation
      if (container) {
        container.style.animation = 'shake 0.5s';
        setTimeout(() => {
          container.style.animation = '';
        }, 500);
      }

      // Alert
      alert(message);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-initialize after AJAX updates
    document.addEventListener('shopify:section:load', init);
  })();
